import { useEffect, useState } from "react";

let subscribers = 0;
let timer: ReturnType<typeof setInterval> | null = null;
const listeners = new Set<(now: number) => void>();

/**
 * ONE application-wide 1 Hz tick.
 *
 * Every elapsed-time display derives from this rather than owning a timer. The
 * reference dashboard ran a separate setInterval inside every agent card, every
 * call row, the header clock and the wallboard — dozens of timers all doing the
 * same thing at slightly different moments, which is both wasteful and visibly
 * jittery when two counters disagree by a second.
 *
 * Store TIMESTAMPS in state and derive elapsed at render. Storing a countdown
 * is what forces a component to own a timer in the first place.
 */
export function useTicker(): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const listener = (t: number) => setNow(t);
    listeners.add(listener);
    subscribers++;

    timer ??= setInterval(() => {
      const t = Date.now();
      for (const l of listeners) l(t);
    }, 1000);

    return () => {
      listeners.delete(listener);
      subscribers--;
      if (subscribers === 0 && timer) {
        clearInterval(timer);
        timer = null;
      }
    };
  }, []);

  return now;
}
